import { errorNotifier, successNotifier } from "../../../components/NotificationHandler";
import http from "../../../services/api";

// Add a new family member
export const addFamilyMember = async (payload, setLoading) => {
  setLoading(true);
  try {
    // Make sure the payload has the expected fields for the API
    const apiPayload = {
      familyName: payload.familyName,
      relationship: payload.relationship,
      familyPhone: payload.phoneNumber || "",
      userId: payload.userId,
      tenantName: payload.tenantName,
    };

    const { data } = await http.post("/user/create-family", apiPayload);
    
    if (data.result && data.result.success) {
      successNotifier(data.result.message || "Family member added successfully");
      return { success: true, data: data.result.data };
    } else {
      errorNotifier(
        data.result?.message || 
        "Failed to add family member"
      );
      return { success: false, message: data.result?.message };
    }
  } catch (error) {
    const errorMessage = 
      error.response?.data?.result?.message ||
      error.response?.data?.message || 
      "An error occurred while adding family member";
    
    errorNotifier(errorMessage);
    return { success: false, message: errorMessage };
  } finally {
    setLoading(false);
  }
};

export const updateFamilyMember = async (memberId, data) => {
  try {
    const response = await http.put(
      `/user/families/${memberId}`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Remove a family member
export const removeFamilyMember = async (memberId, userId, setLoading) => {
  setLoading(true);
  try {
    const response = await http.delete(`/user/families/${userId}/${memberId}`);
    
    if (response.data.result && response.data.result.success) {
      successNotifier(response.data.result.message || "Family member removed successfully");
      return { success: true, data: response.data };
    } else {
      errorNotifier(
        response.data.result?.message || 
        response.data.message || 
        "Failed to remove family member"
      );
      return { success: false, message: response.data.result?.message || response.data.message };
    }
  } catch (error) {
    const errorMessage = 
      error.response?.data?.result?.message ||
      error.response?.data?.message || 
      error.response?.data?.data?.message || 
      "An error occurred while removing family member";
    
    errorNotifier(errorMessage);
    return { success: false, message: errorMessage };
  } finally {
    setLoading(false);
  }
};